<template>
  <v-container fill-height
               fluid
               pa-0
               style="background-image: radial-gradient(farthest-corner at 50% 50%, #004678 20%, #042345 100%);"
  >
    <v-row class="fill-height" no-gutters>
      <top-bar>
        <template v-slot:logos>
          <v-row class="fill-height pt-6 pl-6" no-gutters>
            <v-col class="flex-shrink-1 pr-4" cols="auto">
              <v-img max-width="115" src="@/assets/logos/fitt_logo.svg"></v-img>
            </v-col>
<!--            <v-col class="flex-shrink-1 " cols="auto">-->
<!--              <v-img contain max-width="150" src="@/assets/logos/psychai_logo.png"></v-img>-->
<!--            </v-col>-->
          </v-row>
        </template>
        <template v-slot:title>The OI Career Ownership Game</template>
        <template v-slot:info>
          <v-row class="pt-10 pr-12 white--text" justify="end" no-gutters>
            <div class="title font-weight-light" v-if="timeText">Time:</div>
            <div class="title font-weight-bold mr-12 ml-2" v-if="timeText">{{ timeText }}</div>
            <v-btn dark icon x-large absolute top right style="top: 30px;"
                   @click="$router.replace(`/${$route.params.app}/menu`)"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-row>
        </template>
      </top-bar>
      <v-col cols="12">
        <slw @time="timeText = $event"></slw>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Slw from "@/components/PwcLeadershipGame/Slw";
import TopBar from "@/components/Framework/TopBar";

export default {
  name: "PwcLeadershipGame",
  components: {
    Slw,
    TopBar
  },
  data: () => ({
    timeText: null
  }),
}
</script>

<style scoped>

</style>